import { configureStore } from '@reduxjs/toolkit'
import vehicleReducer from './vehicleSlice'
import autoScanReducer from './autoScanSlice'

export default configureStore({
    reducer: {
      vehicle: vehicleReducer,
      autoScan: autoScanReducer,
    },
  });
  